import React from "react";
import styles from "./PricesList.module.scss";
import { Price } from "../../types/price";
import clsx from "clsx";
import {
  PriceBox,
  PriceBoxBottomLabel,
  PriceBoxTopLabel
} from "../PriceBox/PriceBox";

type PricesListProps = {
  prices: Price[];
  pricesDisclaimer?: string;
  className?: string;
  disclaimerClassName?: string;
  lowestAvailableFareLabel?: string;
};

export const PricesList: React.FC<PricesListProps> = ({
  prices,
  pricesDisclaimer,
  className,
  disclaimerClassName,
  lowestAvailableFareLabel
}) => {
  return (
    <div className={clsx(styles.pricesColumn, className)}>
      {pricesDisclaimer && (
        <PriceBoxTopLabel
          className={clsx(styles.columnTitle, disclaimerClassName)}
        >
          {pricesDisclaimer}
        </PriceBoxTopLabel>
      )}

      <div className={styles.prices}>
        {prices.map((p, index) => {
          return (
            <React.Fragment key={p.fareLabel}>
              {index == 0 ? null : <hr />}
              <PriceBox
                price={p}
                chipBackgroundColor="white"
                priceType={index == 0 ? "primary" : "secondary"}
                topLabel={
                  lowestAvailableFareLabel ? (
                    <PriceBoxTopLabel>
                      {lowestAvailableFareLabel}
                    </PriceBoxTopLabel>
                  ) : undefined
                }
                bottomLabel={
                  lowestAvailableFareLabel ? undefined : (
                    <PriceBoxBottomLabel>{p.fareLabel}</PriceBoxBottomLabel>
                  )
                }
              />
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
